enum SearchType {
  SavedSearch = 'SavedSearch',
  RecentSearch = 'RecentSearch',
  TextSearch = 'TextSearch'
}

export default SearchType;
